interface GetInitials {
  firstName: string;
  lastName: string;
}

export const getInitials = (fullName: GetInitials): string => {
  const initials = Object.values(fullName).map((item: string) =>
    item ? item.charAt(0) : '',
  );
  return initials.join('');
};
